import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { IEventDetailsDTO } from '../../../../../api/events.dao';
import { RoomFormVM } from './room-form.viewmodel';
import { RoomFormPresentation } from './room-form-presentation';
import { CONNECTION_DETAILS_POPOVER_TRACKING_EVENTS, OpenFrom } from '../../../../../tracking-service/tracking-values';
import { IConnectionDetailsDTO } from '../../../../../api/connections.dao';

interface IProps {
    accountId: number;
    event: IEventDetailsDTO;
    saveCompletedCallback: () => void;
    roomId: number;
    openFrom: OpenFrom;
    deleteCompletionCallback?: (roomId: number) => void;
    handleTroubleshoot?: (connection: IConnectionDetailsDTO, openFrom: OpenFrom) => void;
    showConfigurePassportForm?: (connection: IConnectionDetailsDTO) => void;
    trackHostJoinClick?: (eventName: CONNECTION_DETAILS_POPOVER_TRACKING_EVENTS, openFrom: OpenFrom) => void;
}

const RoomForm = withViewModel(RoomFormPresentation, async (props: IProps) => {
    const vm = new RoomFormVM(
        props.accountId,
        props.event,
        props.saveCompletedCallback,
        props.roomId,
        props.openFrom,
        props.deleteCompletionCallback,
        props.handleTroubleshoot,
        props.showConfigurePassportForm,
        props.trackHostJoinClick,
    );
    await vm.initialize();
    return vm;
}, props => [props.accountId, props.event, props.roomId]);

export { RoomForm };